import {normalize} from '../../util/utils';
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function formFilteredActionsReducer(state = initialState.formFilteredActions, action) {
	let newState;
	switch (action.type) {
		case types.GET_ENGAGEMENT_FORM_ACTIONS_BY_DOCUMENTID: {
			if (action.response && !action.error) {
				newState = {...state};

				// Available actions:
				newState.availableActions = action.response.availableActions;

				// Selected actions:
				newState.selectedActions = normalize(action.response.selectedActions, undefined, undefined);

				// Related risks: cant normalize cuz no id field
				newState.risks = action.response.risks;

				newState.summaryResponses = normalize(action.response.summaryResponses, 'smartEvidenceSourceId');

				// Documents:
				let responseDocuments = [];
				for (const doc of action.response.documents) {
					const document = {
						...doc,
						selectedActions: action.response.selectedActions.filter((a) => a.documentId === doc.id).map((a) => a.id)
					};

					responseDocuments.push(document);
				}

				newState.documents = normalize(responseDocuments, undefined, undefined);
			}
			break;
		}
		case types.CLEAN_FORMACTIONS_BY_DOCUMENTID: {
			// Renders Group involvement summary table with up-to-date data.
			return {...state, selectedActions: null, availableActions: null, risks: [], documents: null, summaryResponses: null};
		}
		default: {
			break;
		}
	}

	return newState || state;
}
